// extracted by css-extract-rspack-plugin
export default {"native-select":"native-select___MZGiZQCE"};